import React from "react";
import styled from "styled-components";

// Styles
const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(135deg, #f0f4ff, #d9e7ff);
  border-radius: 16px;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.1);
  padding: 30px 20px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.2);
  }
`;

const CardIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #0066ff, #0099ff);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2.5rem;
  margin-bottom: 15px;
  box-shadow: 0px 4px 15px rgba(0, 102, 255, 0.3);
`;

const CardTitle = styled.h2`
  font-size: 1.75rem;
  color: #333;
  font-weight: 600;
  margin-top: 10px;
  line-height: 1.4;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
  ${Card}:hover & {
    color: #0066ff;
  }
`;

const Subtitle = styled.p`
  font-size: 0.9rem;
  color: #666;
  margin-top: 8px;
  line-height: 1.6;
`;

function VistoCPLP() {
  return (
    <Card>
      <CardIcon>🌎</CardIcon> {/* Ícone de mundo, pode ser trocado conforme preferido */}
      <CardTitle>Visto CPLP</CardTitle>
      <Subtitle>Informações sobre o visto CPLP para cidadãos de países da Comunidade dos Países de Língua Portuguesa.</Subtitle>
    </Card>
  );
}

export default VistoCPLP;
